import cx from "classnames";
import React, { forwardRef } from "react";
import { Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip/Tooltip";
import { Icon } from "@smartsuite/react-ui/lib/components/utils/Icon/Icon";
const EditorToolbarDropdownButtonRaw = ({ title, isOpened, disableTooltip = false, children, showArrow = true, ...rest }, ref) => {
    const className = cx("editor-toolbar-dropdown-button", {
        "editor-toolbar-dropdown-button--opened": isOpened,
        "is-no-arrow": !showArrow,
    });
    return (React.createElement(Tooltip, { placements: ["top", "bottom"], text: title, padding: 2, disabled: disableTooltip, target: React.createElement("button", { ref: ref, className: className, "aria-label": title, type: "button", tabIndex: -1, ...rest },
            children,
            showArrow && (React.createElement(Icon, { name: isOpened ? "arrow-up-small" : "arrow-down-small", size: "S", className: "editor-toolbar-dropdown-button__icon", color: "currentColor", dimension: { width: 14, height: 14 }, transition: true }))) }));
};
export const EditorToolbarDropdownButton = forwardRef(EditorToolbarDropdownButtonRaw);
